module.exports = __webpack_public_path__ + "static/media/social_media.5380efaa.svg";